import { createFileRoute } from "@tanstack/react-router";
import MyListModule from "@/modules/MyListModule";

export const Route = createFileRoute("/_default/my-list")({
  component: RouteComponent,
});

function RouteComponent() {
  return <MyListModule />;
}
